// extracted by mini-css-extract-plugin
module.exports = {"swiperSlide":"Team_swiperSlide__NUYyI"};